import { Box, Divider, Spinner, Text, useToast } from '@chakra-ui/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { format } from 'date-fns';
import exportFromJSON from 'export-from-json';
import { useContext, useEffect, useState } from 'react';
import { BsFillArrowDownSquareFill } from 'react-icons/bs';
import { FaArrowRight } from 'react-icons/fa6';
import { HiOutlineAdjustmentsHorizontal } from 'react-icons/hi2';

import { TooltipComponent } from '../../../../../components/widgets/Tooltip';
import FilterContext from '../../../../../contexts/FilterContext';
import VisualizationContext from '../../../../../contexts/VisualizationContext';
import { apiSensedia } from '../../../../../services/api-sensedia';
import KanbanFiltersModal from '../../kanban/partials/KanbanFiltersModal';

const TableStatusLeads = ({ header }: any) => {
  const { setVisualizationState } = useContext(VisualizationContext);
  const [openModal, setOpenModal] = useState(false);

  const [loadingExportingData, setLoadingExportData] = useState(false);
  const [typeFilter, setTypeFilter] = useState('filtrar');

  const [sellers, setSellers] = useState(null);

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [notFound, setNotFound] = useState(false);
  const [leads, setLeads] = useState([
    {
      CreatedDate: 1701191472618,
      NOME__c: 'teste',
      CPF__c: '',
      Campanha__c: 'Teste',
      LOGIN__c: '00107',
      PRODUTO_ATUAL__c: 'Saude',
      STATUS__c: 'Novas Oportunidades',
      CONTEXTO__c: 'AAAAAAAAAAAA',
      ABORDAGEM__c: null,
      ABORDAGEM_N2__c: null,
      ABORDAGEM_N3__c: null,
      USUARIOS_VISUALIZACOES__c: ['00107']
    },
    {
      CreatedDate: 1701191472618,
      NOME__c: 'teste',
      CPF__c: '',
      Campanha__c: '',
      LOGIN__c: '00107',
      PRODUTO_ATUAL__c: '',
      STATUS__c: 'Novas Oportunidades',
      CONTEXTO__c: '',
      ABORDAGEM__c: null,
      ABORDAGEM_N2__c: 'nao-atendeu',
      ABORDAGEM_N3__c: null,
      USUARIOS_VISUALIZACOES__c: ['00108']
    },
    {
      CreatedDate: 1701191472618,
      NOME__c: 'teste',
      CPF__c: '',
      Campanha__c: '',
      LOGIN__c: '00107',
      PRODUTO_ATUAL__c: '',
      STATUS__c: 'Novas Oportunidades',
      CONTEXTO__c: '',
      ABORDAGEM__c: null,
      ABORDAGEM_N2__c: null,
      ABORDAGEM_N3__c: null,
      USUARIOS_VISUALIZACOES__c: ['00107']
    },
    {
      CreatedDate: 1701191472618,
      NOME__c: 'teste',
      CPF__c: '',
      Campanha__c: '',
      LOGIN__c: '00107',
      PRODUTO_ATUAL__c: '',
      STATUS__c: 'Novas Oportunidades',
      CONTEXTO__c: '',
      ABORDAGEM__c: null,
      ABORDAGEM_N2__c: null,
      ABORDAGEM_N3__c: null,
      USUARIOS_VISUALIZACOES__c: ['00107']
    }
  ]);

  const [vendedores, setVendedores] = useState([
    { id: '00107', nome: 'Teste 1', login: '' }
  ]);
  const [tableCursors, setTableCursors] = useState({
    anterior: null,
    proximo: null
  });
  const [leadsPages, setLeadsPages] = useState(0);
  const [leadsCount, setLeadsCount] = useState(0);
  const { filterObject, setFilterObject, setLoadingFilters, loadingFilters } =
    useContext(FilterContext);

  const toast = useToast();

  const getData = async (cursor: string | void) => {
    setLoading(true);
    setLoadingFilters(true);
    const filterFormatQuery = {
      ...filterObject.query
    };

    const filterFormatHeader = {
      ...filterObject.headers
    };

    for (const filter in filterFormatQuery) {
      if (
        filterFormatQuery[filter] === null ||
        filterFormatQuery[filter] === ''
      ) {
        delete filterFormatQuery[filter];
      }
    }

    for (const filter in filterFormatHeader) {
      if (
        filterFormatHeader[filter] === null ||
        filterFormatHeader[filter] === ''
      ) {
        delete filterFormatHeader[filter];
      }
    }
    const filterURL = '&' + new URLSearchParams(filterFormatQuery).toString();

    try {
      if (!cursor) {
        setPage(1);
      }
      const path = `oportunidades-sulamerica/painel-leads/leads?tamanho-pagina=5${
        cursor ? '&cursor=' + cursor : ''
      }${filterURL !== '&' ? filterURL : ''}`;

      const { data } = await apiSensedia.get(path, {
        headers: { ...filterFormatHeader },
        params: {
          'tipo-consulta': 'gestao'
        }
      });

      setTableCursors({
        proximo: data.proximo_cursor,
        anterior: data.cursor_anterior
      });
      setLeads(data.leads);

      setLeadsPages(data.quantidade_paginas);
      setLeadsCount(data.quantidade_leads);
      if (
        (filterURL !== '&' || filterFormatHeader) &&
        data.quantidade_leads === 0
      ) {
        setNotFound(true);
      } else {
        setNotFound(false);
      }
      setLoadingFilters(false);
      setLoading(false);
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
      setLoading(false);
    }
  };

  const searchSeller = (login: string) => {
    const seller = sellers?.find((vendedor) => {
      return vendedor.id === login;
    });
    if (seller) {
      return seller.nome.length >= 20
        ? seller.nome?.substring(0, 11) + '...'
        : seller.nome;
    }
    return '';
  };
  const searchExportSeller = (login: string) => {
    const seller = sellers?.find((vendedor) => {
      return vendedor.id === login;
    });
    if (seller) {
      return seller.nome;
    }
    return '';
  };

  const searchStatus = (status: string) => {
    switch (status) {
      case 'Novas Oportunidades':
        return 'Novas Oportunidades';
      case 'Agendado':
        return 'Agendado';
      case 'NovoContato':
        return 'Agendado';
      case 'EmNegociacao':
        return 'Em negociação';
      case 'Concluido':
        return 'Concluído';
      default:
        return '-';
    }
  };

  const searchVisualized = (status: boolean) => {
    // if (arrayVisualized) {
    //   const seller = arrayVisualized.find((lead) => {
    //     return lead === user;
    //   });
    //   const actualManager = arrayVisualized.includes(manager?.id);
    //   if (seller || actualManager) {
    //     return (
    //       <span className="tw-text-[#146CFA] tw-font-bold">Visualizado</span>
    //     );
    //   }
    //   return (
    //     <span className="tw-text-[#323232] tw-font-bold">Não visualizado</span>
    //   );
    // }
    // return (
    //   <span className="tw-text-[#323232] tw-font-bold">Não visualizado</span>
    // );

    if (status === true) {
      return (
        <span className="tw-text-[#146CFA] tw-font-bold">Visualizado</span>
      );
    }
    return (
      <span className="tw-text-[#323232] tw-font-bold">Não visualizado</span>
    );
  };

  const searchReason = (reason: string) => {
    switch (reason) {
      case 'lgpd-bloqueado':
        return 'Bloqueado para contato; (LGPD) cliente diz não ter solicitado contato';
      case 'nao-responde':
        return 'Não responde | sem interação nos contatos realizados';
      case 'dados-invalidos':
        return 'Dados inválidos';
      case 'preco':
        return 'Preço';
      case 'fora-rede':
        return 'Fora da rede credenciada | Fora da área de abrangência | Localização';
      case 'concorrencia':
        return 'Concorrência | Fechou com outra Seguradora | Atendido por outro Corretor';
      case 'cnpj-inativo':
        return 'CNPJ inativo | Emissão de certidão negativa';
      case 'mei-menos':
        return 'MEI menos de 6 meses';
      case 'ja-contratou':
        return 'Já contratou';
      case 'converteu-saude':
        return 'Interesse em outros produtos | Converteu Saúde';
      case 'converteu-odonto':
        return 'Interesse em outros produtos | Converteu Odonto';
      case 'converteu-vida':
        return 'Interesse em outros produtos | Converteu Vida';
      case 'converteu-viagem':
        return 'Interesse em outros produtos | Converteu Viagem';
      case 'sem-interesse':
        return 'Não teve interesse';
      case 'recusa-sula':
        return 'Recusa SulAmérica DPS';
      default:
        return '';
    }
  };

  const getUsers = async () => {
    setLoading(true);
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/gestao`,
        {
          timeout: 0
        }
      );

      setSellers(data.perfis);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
    }
  };

  const exportData = async (formatFilters) => {
    try {
      setLoadingExportData(true);
      const limit = 300;

      let cursor = '';
      let leadsExportArray = [];
      let queryStatus = '';
      const exportFormatQuery = {
        ...formatFilters.query
      };
      const exportFormatHeader = {
        ...formatFilters.headers
      };

      for (const filter in exportFormatHeader) {
        if (
          exportFormatHeader[filter] === null ||
          exportFormatHeader[filter] === ''
        ) {
          delete exportFormatHeader[filter];
        }
      }

      for (const filter in exportFormatQuery) {
        if (
          exportFormatQuery[filter] === null ||
          exportFormatQuery[filter] === ''
        ) {
          delete exportFormatQuery[filter];
        }
      }
      const filterURL = '' + new URLSearchParams(exportFormatQuery).toString();

      queryStatus = `${filterURL !== '' ? filterURL : ''}`;

      let lastItem = '';

      while (cursor !== null) {
        const { data: newLeads } = await apiSensedia.get(
          `oportunidades-sulamerica/painel-leads/leads?${queryStatus}&tamanho-pagina=500&tipo-consulta=gestao${
            lastItem !== '' ? `&cursor=${lastItem}` : ''
          }`,
          {
            timeout: 0,
            headers: { ...exportFormatHeader }
          }
        );

        cursor = newLeads.proximo_cursor;
        lastItem = newLeads.proximo_cursor ? newLeads.proximo_cursor : '';
        leadsExportArray = leadsExportArray.concat(newLeads.leads);
      }

      const data = leadsExportArray.map((lead) => {
        return {
          id_lead: lead.ID_LEAD__c,
          id_mdm: lead.ID_MDM__c,
          data_lead: new Date(lead.CreatedDate).toLocaleDateString('pt-BR'),
          nome: lead.NOME__c,
          cpf: lead.CPF__c,
          cpnj: lead.CNPJ__c,
          telefone: lead.TELEFONE__c,
          celular: lead.CELULAR__c,
          email: lead.EMAIL__c,
          segmento: lead.SEGMENTO__c,
          mensagem: lead.MENSAGEM__c?.replace(/[\r\n]/gm, ' '),
          nome_corretor: lead.NOME_CORRETOR__c,
          EV: lead.ESTRUTURA_VENDA__c,
          codigo_produtor: lead.CODIGO_PRODUTOR__c,
          vendedor: searchExportSeller(lead.LOGIN__c),
          status_lead: lead.STATUS__c,
          campanha: lead.Campanha__c,
          lote: lead.LOTE__c,
          data_campanha: lead.DATA_CAMPANHA__c,
          objetivo_campanha: lead.OBJETIVO_CAMPANHA__c,
          descritivo_campanha: lead.DESCRITIVO_CAMPANHA__c,
          data_agendamento:
            lead.STATUS__c === 'NovoContato' && lead.DATA_AGENDAMENTO__c
              ? `${format(
                  new Date(lead.DATA_AGENDAMENTO__c?._seconds * 1000 || 0),
                  'dd/MM/yyyy'
                )} ás ${format(
                  new Date(lead.DATA_AGENDAMENTO__c?._seconds * 1000 || 0),
                  'HH:mm'
                )}`
              : ''
        };
      });
      const fileName = `Export-lead`;
      const exportType = exportFromJSON.types['csv'];

      exportFromJSON({ data, fileName, exportType });

      // await apiSensedia..put(
      //   `/oportunidades-sulamerica/painel-leads/registro-exportacao`
      // );
    } catch (error: any) {
      console.log(error?.response.status);
      if (error?.response.status === 406) {
        toast({
          position: 'top',
          description:
            'Lamentamos, mas não foi possível realizar a pesquisa. Por favor, diminua a quantidade de filtros selecionados e tente novamente.',
          status: 'error',
          duration: 5000,
          isClosable: true
        });
        return;
      }
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });
    } finally {
      setLoadingExportData(false);
    }
  };

  useEffect(() => {
    getData();
  }, [filterObject]);

  useEffect(() => {
    getUsers();
    setVisualizationState('gestao');
  }, []);

  return (
    <>
      <div className="tw-rounded-2xl tw-shadow-lg tw-bg-white tw-pt-1">
        <div className="tw-px-5 w-font-bold tw-mt-[1rem] tw-flex tw-items-center tw-w-full tw-justify-between">
          <div className="tw-w-[100%]">
            <p className="tw-text-[2vh] tw-font-bold">{header}</p>
            <p className="tw-text-[1rem] tw-text-[#001E64] tw-font-normal">
              Quantidade de leads: <span> {leadsCount}</span>
            </p>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <button
              className="tw-bg-[#146CFA] tw-flex tw-items-center tw-text-[1.2rem] tw-justify-center tw-rounded-full tw-w-[15rem] tw-text-center tw-p-[0.5rem]"
              onClick={(e) => {
                e.preventDefault();
                setOpenModal(true);
                setTypeFilter('filtrar');
              }}
            >
              <HiOutlineAdjustmentsHorizontal size={'1.8rem'} color={'white'} />
              <span className="tw-text-[white]">Filtrar leads</span>
            </button>
            <DropdownMenu.Root modal={false}>
              <DropdownMenu.Trigger asChild>
                <button
                  className="tw-pl-1 tw-text-white tw-bg-[#2A4E9A] tw-rounded-full tw-h-12 tw-w-[15rem] tw-text-center"
                  aria-label="Customise options"
                  disabled={loading || loadingExportingData}
                >
                  <span className="tw-pl-1 tw-flex tw-text-[1.2rem] tw-text-white tw-items-center tw-justify-center tw-gap-1">
                    <BsFillArrowDownSquareFill color="white" />
                    <span>
                      {!loadingExportingData ? 'Exportar' : 'Exportando...'}
                    </span>
                  </span>
                </button>
              </DropdownMenu.Trigger>

              <DropdownMenu.Portal>
                <DropdownMenu.Content
                  className="tw-w-[100%] tw-px-4 tw-py-2 tw-bg-white tw-rounded-md tw-p-[5px] tw-shadow-md tw-font-[1.1rem]"
                  sideOffset={5}
                >
                  <span className="tw-font-bold">Exportar:</span>
                  <DropdownMenu.Item
                    onClick={(e) => {
                      setTypeFilter('exportar');
                      setOpenModal(true);
                    }}
                    className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                  >
                    Exportar todos os leads
                  </DropdownMenu.Item>
                  <DropdownMenu.Item
                    className="hover:tw-bg-slate-200 tw-w-[100%] tw-cursor-pointer"
                    onClick={(e) => {
                      setTypeFilter('exportar');
                      setOpenModal(true);
                    }}
                  >
                    Exportar leads por filtro
                  </DropdownMenu.Item>
                </DropdownMenu.Content>
              </DropdownMenu.Portal>
            </DropdownMenu.Root>
          </div>
        </div>
        <Divider orientation="horizontal" my="0.8rem" borderColor={'#CDCDCD'} />
        <div className="tw-w-[100%] tw-px-5 tw-text-[#001E64]">
          {!loading ? (
            <table className="tw-w-[100%] tw-text-[0.8rem] tw-border-separate [border-spacing:0_0.75rem]">
              <thead>
                <tr className="tw-text-left tw-align-bottom">
                  <th className="tw-pl-[1rem]">Entrada</th>
                  <th>
                    Nome
                    <br /> do lead
                  </th>
                  <th>
                    Cliente <br /> PJ/PF
                  </th>
                  <th>Campanha</th>
                  <th>Vendedor(a)</th>
                  <th>Produto</th>
                  <th>Status</th>
                  <th></th>
                  <th>Contexto</th>
                  <th>
                    Visualização
                    <br /> do lead
                  </th>
                </tr>
              </thead>
              <tbody>
                {leads.map((el: any, index: any) => {
                  return (
                    <tr
                      key={index}
                      className={`${
                        +index % 2 > 0 ? 'tw-bg-[#F4F4F4]' : 'tw-bg-[#E9EEF6]'
                      } tw-rounded-2xl tw-h-[3rem] `}
                    >
                      <td className="tw-border-l-[0.3rem] tw-border-solid tw-border-[#FF5000] tw-rounded-[0.4rem_0_0_0.4rem] tw-pl-[0.63rem]">
                        {format(new Date(el?.CreatedDate || 0), 'dd/MM/yyyy') ||
                          '-'}
                        <br />
                        <span>às </span>
                        {format(new Date(el?.CreatedDate || 0), 'HH:mm') || '-'}
                      </td>
                      <td>
                        <TooltipComponent tooltip={el?.NOME__c}>
                          {el.NOME__c?.length >= 20
                            ? el.NOME__c?.substring(0, 11) + '...'
                            : el.NOME__c}
                        </TooltipComponent>
                      </td>
                      <td>
                        {el.CPF__c !== '' || el.CPF__c !== null ? 'PJ' : 'PF'}
                      </td>
                      <td>
                        <TooltipComponent tooltip={el?.Campanha__c}>
                          {el.Campanha__c?.length >= 20
                            ? el.Campanha__c?.substring(0, 11) + '...'
                            : el.Campanha__c}
                        </TooltipComponent>
                      </td>
                      <td>
                        <TooltipComponent tooltip={searchSeller(el.LOGIN__c)}>
                          {searchSeller(el.LOGIN__c) || '-'}
                        </TooltipComponent>
                      </td>
                      <td className="">{el.PDN_ProdutoAtual__c || '-'}</td>
                      <td>{searchStatus(el.STATUS__c) || '-'}</td>

                      <td>
                        <FaArrowRight color={'#FF5000'} />
                      </td>
                      <td>
                        <TooltipComponent
                          tooltip={searchReason(
                            el.ABORDAGEM_N3__c === '' ||
                              el.ABORDAGEM_N3__c === null
                              ? el.ABORDAGEM_N2__c
                              : el.ABORDAGEM_N3__c
                          )}
                        >
                          <span>
                            {searchReason(
                              el.ABORDAGEM_N3__c === '' ||
                                el.ABORDAGEM_N3__c === null
                                ? el.ABORDAGEM_N2__c
                                : el.ABORDAGEM_N3__c
                            )?.length >= 20
                              ? searchReason(
                                  el.ABORDAGEM_N3__c === '' ||
                                    el.ABORDAGEM_N3__c === null
                                    ? el.ABORDAGEM_N2__c
                                    : el.ABORDAGEM_N3__c
                                )?.substring(0, 40) + '...'
                              : searchReason(
                                  el.ABORDAGEM_N3__c === '' ||
                                    el.ABORDAGEM_N3__c === null
                                    ? el.ABORDAGEM_N2__c
                                    : el.ABORDAGEM_N3__c
                                ) || '-'}
                          </span>
                        </TooltipComponent>
                      </td>
                      <td>
                        {searchVisualized(el.LEAD_VISUALIZADO__c) || false}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <Spinner />
          )}
          {notFound === true && leads?.length === 0 && (
            <div className="tw-flex tw-flex-col tw-w-[100%] tw-items-center tw-justify-center tw-my-6">
              <svg
                width="75"
                height="75"
                viewBox="0 0 75 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M37.5 0C58.2113 0 75 16.7887 75 37.5C75 40.2262 74.7113 42.8812 74.1562 45.4425L67.4737 38.7562C67.7489 32.1741 65.8498 25.6843 62.0695 20.2889C58.2893 14.8935 52.8381 10.8924 46.5576 8.90333C40.2771 6.91428 33.5165 7.04787 27.3195 9.28346C21.1225 11.5191 15.8337 15.7323 12.2695 21.2729C8.70535 26.8134 7.06405 33.3731 7.59899 39.9393C8.13393 46.5055 10.8154 52.713 15.2294 57.6036C19.6433 62.4942 25.5444 65.7958 32.0216 66.9988C38.4987 68.2019 45.1918 67.2394 51.0675 64.26C52.4988 66.5285 54.5126 68.3713 56.8988 69.5962C51.0495 73.1403 44.3391 75.0095 37.5 75C16.7888 75 0 58.2112 0 37.5C0 16.7887 16.7888 0 37.5 0ZM63.75 45.645L69.0525 50.9475C70.0847 51.9793 70.7934 53.2899 71.0918 54.7186C71.3901 56.1473 71.2651 57.632 70.7321 58.9907C70.1991 60.3494 69.2812 61.5231 68.091 62.3678C66.9008 63.2126 65.49 63.6917 64.0315 63.7465C62.573 63.8012 61.1303 63.4292 59.8801 62.6761C58.6299 61.923 57.6266 60.8214 56.9932 59.5065C56.3598 58.1916 56.1238 56.7205 56.3142 55.2734C56.5046 53.8264 57.1131 52.4663 58.065 51.36L58.4475 50.9475L63.75 45.645ZM37.5 48.75C42.9975 48.75 47.9437 51.1162 51.375 54.8887L47.8312 58.1137C44.8688 56.9325 41.3175 56.25 37.5 56.25C33.6825 56.25 30.1313 56.9362 27.1687 58.11L23.625 54.885C25.3808 52.9498 27.5226 51.404 29.9125 50.3474C32.3023 49.2907 34.887 48.7465 37.5 48.75ZM24.375 30C25.8668 30 27.2976 30.5926 28.3525 31.6475C29.4074 32.7024 30 34.1332 30 35.625C30 37.1168 29.4074 38.5476 28.3525 39.6025C27.2976 40.6574 25.8668 41.25 24.375 41.25C22.8832 41.25 21.4524 40.6574 20.3975 39.6025C19.3426 38.5476 18.75 37.1168 18.75 35.625C18.75 34.1332 19.3426 32.7024 20.3975 31.6475C21.4524 30.5926 22.8832 30 24.375 30ZM50.625 30C52.1168 30 53.5476 30.5926 54.6025 31.6475C55.6574 32.7024 56.25 34.1332 56.25 35.625C56.25 37.1168 55.6574 38.5476 54.6025 39.6025C53.5476 40.6574 52.1168 41.25 50.625 41.25C49.1332 41.25 47.7024 40.6574 46.6475 39.6025C45.5926 38.5476 45 37.1168 45 35.625C45 34.1332 45.5926 32.7024 46.6475 31.6475C47.7024 30.5926 49.1332 30 50.625 30Z"
                  fill="#D2D2D2"
                />
              </svg>
              <p className="tw-mt-2 tw-text-[#828282]">
                Sua pesquisa não encontrou nenhum resultado correspondente.{' '}
              </p>
            </div>
          )}
        </div>
        <div className="tw-px-5 tw-flex tw-justify-end tw-gap-2 tw-w-[100%] tw-py-8">
          {/* {loading === false && (
            <p className="tw-p-2">
              Exibindo {leads?.length} de {leadsCount}
            </p>
          )} */}
          {/* <PaginateDot
            currentPage={page}
            lastPage={leadsPages}
            maxLength={5}
            setCurrentPage={setPage}
            totalData={leadsCount}
          /> */}

          <button
            className={`tw-px-3 tw-py-1 tw-rounded-lg  tw-text-center tw-font-bold tw-bg-slate-300  ${
              page === 1 && 'tw-opacity-70 tw-cursor-not-allowed'
            }`}
            disabled={page === 1}
            onClick={() => {
              getData(tableCursors.anterior);
              setPage(page - 1);
            }}
          >
            {'Anterior'}
          </button>
          {/* <button className="tw-px-3 tw-py-1 tw-rounded-lg  tw-text-center tw-text-white tw-font-bold tw-bg-[#FF5000]">
            {page}
          </button> */}
          <button
            disabled={leadsPages === page}
            className={`tw-px-3 tw-py-1 tw-rounded-lg  tw-text-center tw-font-bold tw-bg-slate-300 ${
              leadsPages === page && 'tw-opacity-70 tw-cursor-not-allowed'
            }`}
            onClick={() => {
              setPage(page + 1);
              getData(tableCursors.proximo);
            }}
          >
            {'Próximo'}
          </button>
        </div>
      </div>
      <KanbanFiltersModal
        isOpen={openModal}
        setIsOpen={setOpenModal}
        handleExport={exportData}
        type={typeFilter}
        sellers={sellers}
        tipoConsultaCampanhas={'gestao'}
      />
    </>
  );
};

export default TableStatusLeads;
